module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/banner/th-7bc57f66818c266c333c5dd89d53b8f7.jpg";